export namespace Enums {
    export enum ImageQuality {
        Maximum = "Maximum (3840x2160)",
        High = "Haute (2560x1440)",
        Medium = "Moyenne (1920x1080)"
    }

    export enum ImportItemStep {
        NotStarted,
        Importing,
        WaitForUserAction,
        Finished
    }

    // Ref. ISO 639-1
    export enum Locale {
        En = "en",
        Es = "es",
        Fr = "fr",
        It = "it"
    }

    export enum Currency {
         USD = "USD",
         EUR = "EUR",
         GBP = "GBP",
         CHF = "CHF"
    }

    export enum Site {
        Auction = "auction",
        Interencheres = "interencheres"
    }

    export enum PaymentPlatform {
        Stripe = "Stripe",
        Monext = "Monext"
    }

    export enum AuctionType {
        Classic = "classic",
        Live = "live",
        Online = "online"
    }

    export enum ContentTypes {
        Sale = "sale",
        Item = "item",
        OnlineContainer = "online-container",
        OnlineItem = "online-item"
    }

    /**
     * Enum for Item status value
     * @readonly
     * @enum {string} created : created, not published
     * @enum {string} modified / edited : modified, not published
     * @enum {string} confirmed / published : container published
     * @enum {string} trashed : container deleted
     */
    export enum ItemStatus {
        Created = "created",
        Modified = "modified",
        Confirmed = "confirmed",
        Trashed = "trashed"
    }

    /**
     * Enum for containers/sales status value
     * @readonly
     * @enum {string} created : created, not published
     * @enum {string} modified / edited : modified, not published
     * @enum {string} confirmed / published : container published
     * @enum {string} trashed : container deleted
     */
    export enum SaleStatus {
        Created = "created",
        Edited = "edited",
        Published = "published",
        Trashed = "trashed"
    }

    /**
     * State for  items
     * @readonly
     * @enum {string}
     */
    export enum ItemState {
        Suppressed = "suppressed",
        Hidden = "hidden",
        LiveHidden = "liveHidden",
        LiveLimited = "liveLimited"
    }

    /**
     * State for container/sale
     * @readonly
     * @enum {string}
     */
    export enum SaleState {
        Hidden = "hidden",
        Deleted = "deleted",
        Canceled = "canceled"
    }

    export enum OrganizationContract {
        VOLUNTARY = "voluntary",
        JUDICIAL = "judicial"
    }

    export enum OrganizationAuthSort {
        DateAsc = "date_asc",
        DateDesc = "date_desc",
        LastnameAsc = "lastname_asc",
        LastnameDesc = "lastname_desc"
    }

    export enum UserProCompanyCountry {
        FR = "France",
        EU = "EU members",
        WW = "Non-EU members"
    }

    export namespace exportCsv {
        /**
         * Export CSV file names
         * @readonly
         * @enum {string}
         */
        export enum fileName {
            _3ds = "historique", // transactions 3DS
            adj = "pointage", // adjudicataires
            oac = "oac" // ordres d'achat classiques
        }

        /**
         * Export CSV columns header
         */
        export namespace columnsHeaders {
            /**
             * Export CSV formats : 3DS transactions
             * @readonly
             * @enum {string}
             */
            export enum _3ds {
                date = "date",
                civility = "civilite",
                first_name = "prenom",
                last_name = "nom",
                phone_mobile = "mobile",
                phone_landline = "telephone",
                email = "email",
                address = "adresse",
                postcode = "code_postal",
                city = "ville",
                country = "pays",
                payment_status = "etat",
                payment_error_code = "code_erreur",
                payment_organization_comment = "commentaire",
                payment_amount = "montant",
                payment_type = "type",
                comment = "remarque",
                company_name = "denomination_de_la_societe",
                vat_status = "forme_juridique",
                international_vat = "num_immatriculation",
                vat = "num_de_tva_intracommunautaire",
                company_number = "num_siret",
                sale_date = "date_de_vente",
                sale_name = "titre_du_conteneur",
                website = "web_site"
            }

            /**
             * Export CSV formats : Online items buyers
             * @readonly
             * @enum {string}
             */
            export enum adj {
                type = "type",
                order_number = "lot",
                description = "description",
                last_bid_amount = "adj",
                num_live = "numero_acheteur",
                first_name = "prenom",
                last_name = "nom",
                phone_mobile = "mobile",
                phone_landline = "telephone",
                email = "email",
                address = "adresse",
                postcode = "code_postal_csv",
                city = "ville",
                country = "pays",
                payment_card_brand = "carte_bancaire",
                subscription_date = "inscription",
                ip = "ip",
                last_bid_created = "enchere",
                id = "id_lot_online_csv",
                final_price = "adj_frais_compris_ttc",
                commission_rate_price = "frais_cp_ttc",
                online_commission_rate_price = "commissionnement_ttc",
                internal_reference = "ref_interne",
                external_reference = "identifiant_pv2",
                civility = "civilite",
                birthday = "date_de_naissance",
                company_name = "professionnel_denomination_societe",
                company_country = "professionnel_pays_immatriculation",
                vat_status = "professionnel_forme_juridique",
                vat = "professionnel_num_tva_intracommunautaire",
                company_number = "professionnel_num_siret",
                international_vat = "professionnel_num_immatriculation",
                user_uuid = "uuid_internaute_site"
            }

            /**
             * Export CSV formats : Classic Absentee Bids
             * @readonly
             * @enum {string}
             */
            export enum oac {
                type = "type",
                order_number = "lot",
                description = "description",
                amount = "montant",
                num_live = "numero_acheteur",
                first_name = "prenom",
                last_name = "nom",
                phone_mobile = "mobile",
                phone_landline = "telephone",
                email = "email",
                address = "adresse",
                postcode = "code_postal",
                city = "ville",
                country = "pays",
                payment_card_brand = "carte_bancaire",
                subscription_date = "inscription",
                ip = "ip",
                internal_reference = "ref_interne",
                external_reference = "identifiant_pv2",
                civility = "civilite",
                birthday = "date_de_naissance",
                company_name = "professionnel_denomination_societe",
                company_country = "professionnel_pays_immatriculation",
                vat_status = "professionnel_forme_juridique",
                vat = "professionnel_num_tva_intracommunautaire",
                company_number = "professionnel_num_siret",
                international_vat = "professionnel_num_immatriculation",
                user_uuid = "uuid_internaute_site",
                user_comment = "commentaire_internaute"
            }
        }
    }

    export enum LangLabel {
        en = "English",
        es = "Español",
        fr = "Français",
        it = "Italiano"
    }

    export enum Filter {
        Canceled = "canceled",
        Hidden = "hidden",
        Query = "query",
        Past = "past",
        From = "from",
        To = "to",
        Category = "category",
        Field = "field",
        Status = "status"
    }
}

export enum MultiSelectType {
    SaleUpcoming = "sale.upcoming",
    SalePublished = "sale.published",
    SalePast = "sale.past"
}

export enum Events {
    ItemsLoaded = "items.loaded",
    ItemUpdated = "item.updated",
    MultiSelectAll = "ms.selectAll",
    MultiSelectAllOnline = "ms.selectAll.online",
    OnlineItemsFilter = "online-items.filter",
    OnlineItemsLoaded = "online-items.loaded",
    // online items are loaded and online/payment data is associated to its relative item
    OnlineItemsSetted = "online-items.setted",
    OnlineItemsPaymentsUpdated = "online-items.payment.updated",
    OnlineItemCreated = "online-item.created",
    OnlineItemUpdated = "online-item.updated",
    OnlineSalePaymentsUpdated = "online-container.payments.updated",
    OnlineSalePurged = "container.purged",
    OnlineSaleUpdated = "online-container.updated",
    OrganizationFilterUpdated = "organization-filter.updated",
    PastItemPublished = "past-item.published",
    SaleLoaded = "sale.loaded",
    SaleUpdated = "sale.updated",
    SaleRelatedObjectUpdated = "saleRelatedObject.updated",
    PostMessageToV2 = "postMessageToV2",
    ImportFile = "importFile"
}

export enum ApiErrorMessage {
    DraftOnlineSalePublished = "Cannot create a draft of an active online sale",
    OnlineSaleStarted = "Online sale has already started"
}

export enum HttpStatusCode {
    ConnectionReset = -1,
    Ok = 200,
    NoContent = 204,
    NotModified = 304,
    Unauthorized = 401,
    Forbidden = 403,
    NotFound = 404,
    PayloadTooLarge = 413,
    InternalServerError = 500,
    BadGateway = 502
}

export enum StorageKey {
    AfterLoginRedirect = "afterLoginRedirect",
    PendingRequest = "pendingRequest"
}
